import useActionPending from "@hooks/useActionPending";
import theme from "@styles/theme";
import { Grid, MenuItem, Select, Skeleton, Stack, Tooltip } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";
import { ImageFolderSmallOn } from "@mzc-cloudplex/icons";
import React, { useEffect, useState } from "react";
import useVirtualFolderPath from "@hooks/useVirtualFolderPath";
import { useTranslation } from "react-i18next";

const RecentFolderLocation = ({ domain, subDomain, driveInfo, onChangeRecentLocation }) => {
    const { t } = useTranslation();
    const { getLocalStorageRecentLocation } = useVirtualFolderPath({
        domain,
        subDomain,
        driveInfo,
    });
    const [recentLocation, setRecentLocation] = useState([]);
    const {
        pending: recentLocationPending,
        setActionPending: setRecentLocationPending,
        disableActionPending: disableRecentLocationPending,
    } = useActionPending("getLocalStorageRecentLocation");

    const getRecentLocations = async () => {
        setRecentLocationPending();
        const recentLocations = await getLocalStorageRecentLocation();
        disableRecentLocationPending();
        setRecentLocation(recentLocations);
    };

    const onHandleChangeRecentLocation = (e) => {
        const locationId = e.target.value;
        const locationInfo = recentLocation?.find((el) => el.value === locationId);
        const locations = locationInfo?.label?.split("/").map((el) => ({ name: el }));
        onChangeRecentLocation({ locationId, locations });
    };

    useEffect(() => {
        getRecentLocations();
    }, []);

    return (
        <Select
            variant={"filled"}
            displayEmpty
            onChange={onHandleChangeRecentLocation}
            sx={{
                backgroundColor: theme.palette.common.white,
            }}
            value={""}
        >
            <MenuItem
                disabled
                sx={{
                    display: "none",
                }}
                value=""
            >
                <Typography variant={"body3"} color={theme.palette.secondary[800]}>
                    {t(`common::label::Select by Recent Location`, `Select by Recent Location`)}
                </Typography>
            </MenuItem>
            {recentLocationPending ? (
                <Grid container px={1.5} py={0.5} gap={1}>
                    {new Array(3).fill("").map((_, i) => (
                        <Grid container flexDirection={"row"} gap={1}>
                            <Skeleton variant={"rounded"} animation={"wave"} width={22} height={22} />
                            <Grid item flex={1}>
                                <Skeleton variant={"rounded"} animation={"wave"} width={"100%"} height={22} />
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                recentLocation?.map((option, index) => (
                    <Tooltip
                        key={`recent-location-${index}`}
                        title={option.label}
                        placement="left"
                        value={option.value}
                    >
                        <MenuItem value={option.value}>
                            <Stack direction={"row"} gap={1} alignItems={"center"}>
                                <ImageFolderSmallOn width={16} height={16} />
                                <Typography component="span" variant="body1">
                                    {option.label?.substring(option.label?.lastIndexOf("/") + 1)}
                                </Typography>
                            </Stack>
                        </MenuItem>
                    </Tooltip>
                ))
            )}
        </Select>
    );
};

export default RecentFolderLocation;
